export default __webpack_public_path__ + "static/corners_of_wisdom-e869539b40763e02c32eec03037ae070.png";